import React from 'react';
import { HistoryTable } from './HistoryTable';
import { SeeAll } from '../Components/SeeAll';
import CardTransactionSummary from '../Components/CardTransactionSumary';
import { LoadingMode } from '../Components/LoadingMode';
import { useHistortyData } from './useHistortyData';

export const TransactionHistory = () => {
  const {
    historyDataArray,
    transactionHistoryDetails,
    handleOpenandCloseModal,
    openModal,
    isLoading,
    transactionHistory,
  } = useHistortyData();

  return (
    <div className='mx-6 mt-8 flex flex-col gap-6'>
      <SeeAll name='Transaction History' seeAll={false} />
      {isLoading ? (
        <LoadingMode />
      ) : transactionHistory.length === 0 ? (
        <p className='text-center texxt-red-500 p-6 bg-p-bk/5'>
          You have no transaction history.
        </p>
      ) : (
        <>
          <div className='flex flex-col gap-16'>
            <CardTransactionSummary content={{ transactionHistory }} />
            <HistoryTable
              content={{
                historyDataArray,
                transactionHistoryDetails,
                handleOpenandCloseModal,
                openModal,
              }}
            />
          </div>
        </>
      )}
    </div>
  );
};
